export default __webpack_public_path__ + "static/media/account_tree_black_24dp.ed368ef8.svg";